import React, { Component } from "react";
import Protected from "./_hoc/Protected";
import { connect } from "react-redux";
import * as userActions from "./_actions/userActions";
import { Switch, Route, withRouter } from "react-router-dom";
import LoginPage from "./_components/LoginPage";

class App extends Component {
  componentDidMount() {
    const { isLoggedIn, location } = this.props;
    this.props.isLoggedIn({ url: location.pathname });
  }
  render() {
    return (
      <Switch>
        <Route exact path="/login" component={LoginPage} />
        <Route path="/" component={Protected} />
      </Switch>
    );
  }
}
const mapDispatchToProps = dispatch => {
  return {
    isLoggedIn: payload => dispatch(userActions.isUserAlreadyLoggedIn(payload))
  };
};

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(App)
);



// WEBPACK FOOTER //
// ./src/App.js